import { DATE_FORMAT as DATE_FORMAT_ORIGINAL } from '@r-client/shared/util/formats';

/**
 * @deprecated
 * import from shared/util/formats instead
 * */
export const DATE_FORMAT = DATE_FORMAT_ORIGINAL;
